import { useState } from "react";

interface ISoundSelector {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string; file: string }[];
  label?: string;
}

// SVG Icon for play button
const SpeakerIcon = ({ className = "h-4 w-4" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z"
    />
  </svg>
);

function SoundSelector({ value, onChange, options, label }: ISoundSelector) {
  const [isPlaying, setIsPlaying] = useState(false);

  const playSound = (soundFile: string) => {
    if (soundFile === "none" || !soundFile) return;

    setIsPlaying(true);
    const audio = new Audio(`/sounds/${soundFile}`);
    audio.play().catch((error) => {
      console.error("Error playing sound:", error);
      setIsPlaying(false);
    });

    // Re-enable button after 1.5 seconds
    setTimeout(() => {
      setIsPlaying(false);
    }, 1500);
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className="flex items-center gap-2">
      {label && <div className="text-sm font-medium">{label}</div>}
      <select
        value={value}
        onChange={handleChange}
        className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {selectedOption?.file ? (
        <button
          onClick={() => playSound(selectedOption.file)}
          className={`rounded p-1.5 hover:bg-gray-200 dark:hover:bg-gray-600 ${
            isPlaying ? "opacity-50" : ""
          }`}
          disabled={isPlaying}
          aria-label="Preview sound"
          title="Preview sound"
        >
          <SpeakerIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" />
        </button>
      ) : (
        <div className="h-[28px] w-[28px]" id="empty sound placeHolder"></div>
      )}
    </div>
  );
}

export default SoundSelector;
